export const SCARCITY_TYPE_24H = '24h'
export const SCARCITY_TYPE_NUM_OF_FAVORITES = 'number_of_favorites'
export const SCARCITY_TYPE_NONE = 'none'

export const SCARCITY_TRACKING_TYPE_24H = 'with_scarcity_24hours'
export const SCARCITY_TRACKING_TYPE_FAVORITES = 'with_scarcity_lotoflikes'
export const SCARCITY_TRACKING_TYPE_EMPTY = 'without_scarcity'

export const SCARCITY_TRACKING_INFO_MAP = {
  [SCARCITY_TYPE_24H]: SCARCITY_TRACKING_TYPE_24H,
  [SCARCITY_TYPE_NUM_OF_FAVORITES]: SCARCITY_TRACKING_TYPE_FAVORITES,
  [SCARCITY_TYPE_NONE]: SCARCITY_TRACKING_TYPE_EMPTY
}
